import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["format-key", "href", "data-qa"]
const _hoisted_2 = ["format-key"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_title, { as: "h2" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.Faq.FaqPageHeader), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sections, (article) => {
      return (_openBlock(), _createElementBlock("article", {
        key: article.key
      }, [
        _createVNode(_component_base_title, {
          as: article.headingTag,
          level: "h4",
          class: "_mt-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(article.title), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["as"]),
        _createElementVNode("p", null, [
          (article.isCustomComponent)
            ? (_openBlock(), _createBlock(_component_localize, {
                key: 0,
                resource: article.text
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.children, (child) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (child.isLink)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: child.key,
                            "format-key": child.formatKey,
                            href: child.href,
                            class: "gfu-link gfu-link--accent",
                            "data-qa": child.dataQa
                          }, _toDisplayString(child.text), 9 /* TEXT, PROPS */, _hoisted_1))
                        : (_openBlock(), _createElementBlock("span", {
                            key: child.key,
                            "format-key": child.formatKey
                          }, _toDisplayString(child.text), 9 /* TEXT, PROPS */, _hoisted_2))
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(article.text), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}